import { useContext, useEffect, useState } from "react"
import { message } from "./Message"
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface"
import { actionAddDataLayer, MapitStateContext } from "src/states/MapitState"
import { bbox, featureCollection } from "@turf/turf"
import { Localization } from "@viamap/viamap2-common"
import { parse as WKTparse } from "wkt"
import { LayerInfo } from "src/common/managers/Types"
import { GenerateGeomUtils } from "src/managers/GenerateGeomUtils"
import { LayerFunc } from "src/managers/LayerFunc"
import { MitLatLng } from "src/managers/MapFacade"
import { FileImportContext } from "./FileImporter"
import { FileImportType } from "./FileImportHooks"

export function InsideQueryHandler() {
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext)
  const { importCallBack: importCB } = useContext(FileImportContext)
  const [layerInfos, setLayerInfos] = useState<LayerInfo[]>([])

  useEffect(() => {
    let x = async () => {
      const query = new URLSearchParams(new URL(document.URL.toLowerCase()).search)
      const ResultetLayerInfos: LayerInfo[] = []
      if (query.has("sfenummer")) {
        let SFEPromise = query.getAll("sfenummer").flatMap((sfe) => sfe.split(/[ ,+]/)).map(async (sfe) => {
          try {
            let geojson = await PropertyInfoInterface.getGeojsonOfSFE(parseInt(sfe))
            let layerInfo = LayerFunc.createLayerInfoFromGeoJsonFeature(geojson.features[0], sfe + " (sfe)");
            layerInfo && ResultetLayerInfos.push(layerInfo);
          } catch (e) {
            console.error(e)
            message.error(Localization.getText("No geometry data for this property " + sfe + " found."));
          }
          return undefined;
        })
        await Promise.all(SFEPromise)
      }
      if (query.has("bfenummer")) {
        let BFEPromise = query.getAll("bfenummer").flatMap((bfe) => bfe.split(/[ ,+]/)).map(async (bf) => {
          let EBR = await PropertyInfoInterface.EBRadresseForBFE(bf)
          let geometri = EBR.features?.[0]?.properties?.adresse?.[0]?.husnummer?.adgangspunkt?.position;
          if (geometri) {
            let tmp = WKTparse(geometri)
            if (tmp?.coordinates[0]) {
              let coords = GenerateGeomUtils.convertFromUTMtoLatLng({ x: tmp.coordinates[0], y: tmp.coordinates[1] })
              let layerInfo = LayerFunc.createLayerInfoForOnePoint(new MitLatLng(coords.lat, coords.lng), bf + " (bfe)", { BFEnummer: bf.toString() });
              layerInfo && ResultetLayerInfos.push(layerInfo);
            }
          }
          let geometri2 = EBR.features?.[0]?.properties?.husnummer?.[0]?.adgangspunkt?.position
          if (geometri2) {
            let tmp = WKTparse(geometri2)
            if (tmp?.coordinates[0]) {
              let coords = GenerateGeomUtils.convertFromUTMtoLatLng({ x: tmp.coordinates[0], y: tmp.coordinates[1] })
              let layerInfo = LayerFunc.createLayerInfoForOnePoint(new MitLatLng(coords.lat, coords.lng), bf + " (bfe)", { BFEnummer: bf.toString() });
              layerInfo && ResultetLayerInfos.push(layerInfo);
            }
          }
        });
        await Promise.all(BFEPromise)
      }
      if (query.has("openlink")) {
        let linkId = query.get("openlink")
        if (linkId) {
          importCB({ fileImportType: FileImportType.FileFetch, url: linkId })
          window.history.replaceState(null, document.title, "/")
        }
      }

      if (ResultetLayerInfos.length > 0) {
        setLayerInfos(ResultetLayerInfos)
      }
    }
    x()
  }, [])

  useEffect(() => {
    if (layerInfos.length > 0) {
      layerInfos.forEach((layerInfo) => {
        mapitStateDispatch(actionAddDataLayer(layerInfo, false))
      })
      if (mapitState.map) {
        const bboxCoords = bbox(featureCollection(layerInfos.map((li) => li.geoJson?.features[0] as any)))
        mapitState.map.getMapPop().fitBounds(bboxCoords as any, { padding: 20, maxZoom: 16 })
        setLayerInfos([])
        window.history.replaceState(null, document.title, "/")
      }
    }
  }, [layerInfos, mapitState.map])

  return null
}